import { createApi } from "./client";
import type { Service } from "../types/models";

export function listServices(
    apiBase: string,
    companySlug: string
): Promise<Service[]> {
    const api = createApi(apiBase);

    return api<Service[]>(`/api/companies/${companySlug}/services`);
}
